import React, {useEffect, useRef, useState} from "react";
import styled from "styled-components";
import {Accordion, Col, Container, Form, Row} from "react-bootstrap";
import {CSSPlugin, gsap, TimelineLite} from "gsap";
import {Link, useLocation, NavLink, useHistory} from "react-router-dom";
import {hover} from "../styles/globalStyleVars";


const MainMenu = ({color}) => {
    const location = useLocation();
    gsap.registerPlugin(CSSPlugin);
    const tl = new TimelineLite();
    const mobileMenuRaf = useRef();
    const menuRef = useRef();
    const hamburgerRef = useRef();
    const hamburgerCloseRef = useRef();
    const containerRef = useRef();
    const [isStickyMenuActive, setIsStickyMenuActive] = useState(false);

    const [scrollUp, setScrollUp] = useState(false);
    const [scrollDown, setScrollDown] = useState(false);
    const [isSticky, setIsSticky] = useState(false);
    const history = useHistory();

    useEffect(() => {
        // menu click on mobile
        if (hamburgerRef.current) {
            hamburgerRef.current.addEventListener("click", handleMenuOpen);
        }
        if (hamburgerCloseRef.current) {
            hamburgerCloseRef.current.addEventListener("click", handleMenuClose);
        }

        const getLinkTag = document.querySelectorAll("a");
        for (let i of getLinkTag) {
            i.addEventListener("click", handleMenuClose);
        }

        return () => {
            if (hamburgerRef.current) {
                hamburgerRef.current.removeEventListener("click", handleMenuOpen);
            }
            if (hamburgerCloseRef.current) {
                hamburgerCloseRef.current.removeEventListener("click", handleMenuClose);
            }

            // Remove event listeners from link tags
            for (let i of getLinkTag) {
                i.removeEventListener("click", handleMenuClose);
            }
        };
    }, []);


    const handleMenuOpen = () => {
        document.querySelector(".hamburger").classList.add("menu-open");
        document.querySelector(".Mobile-menu-wrap").classList.add("menu-visible");
        document.body.classList.add("menu-showed");

        // Set the body's overflow to hidden
        gsap.set(document.body, {
            overflow: "hidden",
        });

        gsap.to(menuRef.current, {
            duration: 0.8,
            x:'0%',
            ease: "power4.inOut"
        });
    };

    const handleMenuClose = () => {
        document.querySelector(".hamburger").classList.remove("menu-open");
        document.querySelector(".Mobile-menu-wrap").classList.remove("menu-visible");
        document
            .querySelector(".Mobile-menu-wrap")
            .classList.remove("contact-slided");
        document.body.classList.remove("menu-showed");

        // Set the body's overflow to visible
        gsap.set(document.body, {
            overflow: "visible",
        });

        gsap.to(menuRef.current, {
            duration: 0.8,
            x:'100%',
            ease: "power4.inOut",
            onComplete: function () {
                gsap.set(menuRef.current, {

                });
            },
        });
    };


    return (

        <StyledMobileMenu
            className={`${isSticky ? 'sticky' : ''} ${scrollDown ? 'scroll-down' : ''} ${scrollUp ? 'scroll-up' : ''}  Mobile-menu-wrap menu-bar`}>
            <Container>
                <Row className="mobile-menu" ref={mobileMenuRaf}>
                    <Col className="logo">
                        <Link to={'/'}>
                            <svg id="Group_21239" data-name="Group 21239" xmlns="http://www.w3.org/2000/svg"
                                 xmlnsXlink="http://www.w3.org/1999/xlink" width="97" height="97" viewBox="0 0 97 97">
                                <defs>
                                    <clipPath id="clip-path">
                                        <rect id="Rectangle_5842" data-name="Rectangle 5842" width="67.339"
                                              height="82.249" fill="none"/>
                                    </clipPath>
                                </defs>
                                <rect id="Rectangle_5842-2" data-name="Rectangle 5842" width="97" height="97"
                                      fill="transparent"/>
                                <g id="Group_20865" data-name="Group 20865" transform="translate(14.83 7.376)"
                                   clip-path="url(#clip-path)">
                                    <path id="Path_8656" data-name="Path 8656"
                                          d="M126.384,19.983c-.339-.6-1.384.089-1.384.089a70.676,70.676,0,0,0-9.968,1.16,31.33,31.33,0,0,0,8.437-9.971c.9-.261,1.123-.782.78-1.151-.461-.548-1.315.368-1.315.368a67.85,67.85,0,0,0-11.507,4.081,29.188,29.188,0,0,0,4.016-9.867c.78-.459.865-1.022.433-1.3-.6-.382-1.172.688-1.172.688a66.546,66.546,0,0,0-7.535,4.955,38.091,38.091,0,0,0-3.106-7.077c.477-1.289,0-1.995-.8-1.958-1.143.076-.721,1.881-.721,1.881-.916,2.309-1.7,4.485-2.35,6.56A32.564,32.564,0,0,0,91,3.749c-.379-.815-.946-.963-1.313-.584-.489.505.567,1.189.567,1.189A59.011,59.011,0,0,0,96.22,14.8a34.531,34.531,0,0,0-12.93-4.009c-.561-.7-1.159-.727-1.421-.3-.372.6.823,1.048.823,1.048a62.865,62.865,0,0,0,8.187,8.824,33.619,33.619,0,0,0-10.388-.871c-.7-.594-1.283-.511-1.461-.048-.238.659,1.032.892,1.032.892A56.1,56.1,0,0,0,94.272,30a8.287,8.287,0,0,1,3.417-2.1L98,27.171a13.97,13.97,0,0,1,3.814,2.742v5.419c-2.288-1.457-6.621-3.784-9.877-3.155-1.332.27-13.556,1.749-9.866,16.094.837,3.25,5.3,11.022,18.131,20.618.7.529,2.63,2.417,2.965,3.635.319-1.217,2.258-3.105,2.966-3.635,12.822-9.6,17.289-17.368,18.125-20.618,3.69-14.345-8.531-15.823-9.859-16.094-3.306-.629-7.662,1.738-9.936,3.187V30a10.223,10.223,0,0,1,3.024-2.134l.244.547a11.008,11.008,0,0,1,3.327,2.1,33.623,33.623,0,0,0,14.286-9.57c.939-.046,1.269-.516,1.036-.957M96.609,26.607,81.545,20.548c4.569-1.152,14.641,2.588,15.313,2.86-.207,1.836-.249,2.951-.249,3.2M97,22.365h-.019s.019,0,.019-.013Zm.311-2.108-13.2-8.25c4.07-.3,11.452,3.663,13.814,5.02-.245,1.159-.447,2.247-.611,3.23M99,12.529l-7.488-7.42c2.455.348,5.686,2.46,8.324,4.485-.306,1.013-.6,1.991-.836,2.935m22.956-.976C120.622,16,111.483,22.522,111.483,22.522a8.873,8.873,0,0,0-1.837-.846c-.025-.535-.07-1.065-.116-1.573ZM114.08,5.37c-.017,2.875-2.7,7.292-4.748,10.2a3.323,3.323,0,0,1-.395.225c-.228-1.19-.482-2.317-.763-3.393ZM105.631,49.9a2.421,2.421,0,0,1-4.832,0,2.25,2.25,0,0,1,1.02-1.853V36.937h2.648V47.954a2.239,2.239,0,0,1,1.163,1.941M103.1,29.378V4.008c4.662,5.586,4.966,22.212,4.966,22.212a12.483,12.483,0,0,0-4.966,3.158m7.931.089a8.455,8.455,0,0,0-3-1.882c.922-.47,1.654-.763,1.654-.763V26.7L123.81,20.94c-2.336,4.043-12.781,8.527-12.781,8.527"
                                          transform="translate(-69.858 0)" fill="#e50019"/>
                                    <path id="Path_8657" data-name="Path 8657"
                                          d="M3.716,332.1l-.16.871,3.478.822A38.843,38.843,0,0,0,3.2,334.921l-.153.831,5.385.8.136-.727-3.526-.621q1.931-.615,3.825-1.016l.116-.7Z"
                                          transform="translate(-2.697 -293.659)" fill="#ffffff"/>
                                    <path id="Path_8658" data-name="Path 8658"
                                          d="M3.82,375.139a1.57,1.57,0,0,0,.44-.425,1.081,1.081,0,0,0,.172-.5,1.308,1.308,0,0,0-.538-1.068,2.913,2.913,0,0,0-1.495-.612,2.236,2.236,0,0,0-1.526.3A1.371,1.371,0,0,0,.2,373.917a1.214,1.214,0,0,0,.091.553,1.617,1.617,0,0,0,.379.522l-.426-.014-.05.857,4.02.078.05-.755Zm-.69-.242a1.431,1.431,0,0,1-.871.207,1.354,1.354,0,0,1-.847-.3.8.8,0,0,1-.294-.675.771.771,0,0,1,.371-.612,1.349,1.349,0,0,1,.872-.179,1.553,1.553,0,0,1,.83.323.762.762,0,0,1,.292.635.742.742,0,0,1-.354.6"
                                          transform="translate(-0.173 -329.397)" fill="#ffffff"/>
                                    <path id="Path_8659" data-name="Path 8659"
                                          d="M4.025,406.328l0-.387-.872,0,.006.4L0,406.37l.043.856,3.148-.107.023.461.866-.043-.022-.447,1.486-.054-.037-.717Z"
                                          transform="translate(0 -358.954)" fill="#ffffff"/>
                                    <path id="Path_8660" data-name="Path 8660"
                                          d="M6.188,421.268a.752.752,0,0,0-.458-.11.78.78,0,0,0-.465.169.426.426,0,0,0-.177.351.39.39,0,0,0,.2.322.75.75,0,0,0,.47.089.762.762,0,0,0,.456-.169.41.41,0,0,0,.177-.336.379.379,0,0,0-.206-.315m-5.481.292.043.857,4.009-.34-.035-.756Z"
                                          transform="translate(-0.625 -372.411)" fill="#ffffff"/>
                                    <path id="Path_8661" data-name="Path 8661"
                                          d="M5.969,435.833a2.488,2.488,0,0,0-1.642-.364,2.125,2.125,0,0,0-1.415.669,1.532,1.532,0,0,0-.434,1.321,1.593,1.593,0,0,0,.41.858,1.694,1.694,0,0,0,.86.491,2.321,2.321,0,0,0,1.079.008,2.692,2.692,0,0,0,1-.434,2.11,2.11,0,0,0,.678-.743,1.387,1.387,0,0,0,.164-.839,1.372,1.372,0,0,0-.694-.967m-.477,1.789a1.454,1.454,0,0,1-.792.39,1.275,1.275,0,0,1-.872-.1.776.776,0,0,1-.413-.595.762.762,0,0,1,.224-.686,1.284,1.284,0,0,1,.8-.363,1.406,1.406,0,0,1,.866.13.756.756,0,0,1,.416.557.767.767,0,0,1-.233.665"
                                          transform="translate(-2.176 -385.053)" fill="#ffffff"/>
                                    <path id="Path_8662" data-name="Path 8662"
                                          d="M7.251,466.954l.2.836,1.569-.409a7.122,7.122,0,0,1,.8-.18,1.263,1.263,0,0,1,.61.09.488.488,0,0,1,.293.337.461.461,0,0,1-.049.332.672.672,0,0,1-.305.274,5.6,5.6,0,0,1-.905.328l-1.688.521.232.819,2.532-.849a1.8,1.8,0,0,0,.909-.584.987.987,0,0,0,.217-.863.81.81,0,0,0-.207-.383,1.917,1.917,0,0,0-.505-.359l.4-.1-.185-.741Z"
                                          transform="translate(-6.412 -412.086)" fill="#ffffff"/>
                                    <path id="Path_8663" data-name="Path 8663"
                                          d="M22.711,499.42a2.073,2.073,0,0,0,.209-.569.964.964,0,0,0-.043-.539,1.151,1.151,0,0,0-.887-.728,2.632,2.632,0,0,0-1.586.119,2.352,2.352,0,0,0-1.263.953,1.477,1.477,0,0,0-.189,1.3,1.2,1.2,0,0,0,.3.47,1.361,1.361,0,0,0,.559.3l-.4.171.361.778,3.66-1.759-.323-.682Zm-.742.105a1.412,1.412,0,0,1-.677.569,1.386,1.386,0,0,1-.9.132.723.723,0,0,1-.518-.486.8.8,0,0,1,.1-.733,1.4,1.4,0,0,1,.718-.552,1.341,1.341,0,0,1,.879-.077.676.676,0,0,1,.5.439.831.831,0,0,1-.1.707"
                                          transform="translate(-16.691 -439.928)" fill="#ffffff"/>
                                    <path id="Path_8664" data-name="Path 8664"
                                          d="M29.462,520.089l.36.773,4.948-2.677-.294-.648Z"
                                          transform="translate(-26.052 -457.635)" fill="#ffffff"/>
                                    <path id="Path_8665" data-name="Path 8665"
                                          d="M43.627,543.517l.452.764,2-1.361a11.237,11.237,0,0,0,.791,1.177l-1.935,1.457.512.712,4.325-3.435-.426-.6-1.667,1.254a11.338,11.338,0,0,1-.767-1.137l1.712-1.177-.372-.643Z"
                                          transform="translate(-38.578 -477.968)" fill="#ffffff"/>
                                    <path id="Path_8666" data-name="Path 8666"
                                          d="M71.871,582.229a2.948,2.948,0,0,0,.854-1.505,1.455,1.455,0,0,0-.305-1.3A1.351,1.351,0,0,0,71.229,579a2.76,2.76,0,0,0-2.334,2,1.559,1.559,0,0,0,.384,1.38,1.719,1.719,0,0,0,.738.517,1.656,1.656,0,0,0,.9-.005l-.164-.809a.954.954,0,0,1-.817-.32.9.9,0,0,1-.228-.655,1.213,1.213,0,0,1,.324-.686l1.7,1.948Zm-1.2-2.309a1.529,1.529,0,0,1,.583-.141.768.768,0,0,1,.549.262.752.752,0,0,1,.183.543,1.21,1.21,0,0,1-.2.616Z"
                                          transform="translate(-60.891 -511.979)" fill="#ffffff"/>
                                    <path id="Path_8667" data-name="Path 8667"
                                          d="M95.591,603.087a1.679,1.679,0,0,0-.048-.623.97.97,0,0,0-.276-.449,1.144,1.144,0,0,0-1.123-.226,2.834,2.834,0,0,0-1.371.844,2.493,2.493,0,0,0-.721,1.44,1.43,1.43,0,0,0,.4,1.237,1.158,1.158,0,0,0,.477.268,1.518,1.518,0,0,0,.623.018l-.282.342.635.547,2.531-3.26-.561-.486Zm-.609.428a1.544,1.544,0,0,1-.377.84,1.319,1.319,0,0,1-.74.512.7.7,0,0,1-.682-.175.818.818,0,0,1-.233-.7,1.689,1.689,0,0,1,1.159-1.3.662.662,0,0,1,.654.154.783.783,0,0,1,.22.669"
                                          transform="translate(-81.391 -532.092)" fill="#ffffff"/>
                                    <path id="Path_8668" data-name="Path 8668"
                                          d="M112.632,620.936l.652.508.963-1.367.117-.161a3.533,3.533,0,0,1,.766-.878c.179-.115.313-.134.41-.062a.484.484,0,0,1,.116.207l.684-.6a.537.537,0,0,0-.177-.266.5.5,0,0,0-.384-.1,1.14,1.14,0,0,0-.488.211l.305-.422-.5-.388Z"
                                          transform="translate(-99.596 -546.134)" fill="#ffffff"/>
                                    <path id="Path_8669" data-name="Path 8669"
                                          d="M130.636,618.6l-.3-.23-.493.742.31.238-1.761,2.728.707.448,1.7-2.773.377.238.46-.773-.374-.23.8-1.3-.592-.374Z"
                                          transform="translate(-113.532 -545.869)" fill="#ffffff"/>
                                    <path id="Path_8670" data-name="Path 8670"
                                          d="M155.117,636.651l.763.387,1.085-2.293,1.142.58.4-.948-1.1-.556.437-.926,1.069.544.417-.961-1.674-.842Z"
                                          transform="translate(-137.163 -558.529)" fill="#ffffff"/>
                                    <path id="Path_8671" data-name="Path 8671"
                                          d="M182.464,655.76a2.635,2.635,0,0,0-1.092,1.307,2.36,2.36,0,0,0-.129,1.621,1.506,1.506,0,0,0,.9,1.034,1.453,1.453,0,0,0,.921.044,1.725,1.725,0,0,0,.83-.546,2.549,2.549,0,0,0,.523-.99,2.871,2.871,0,0,0,.117-1.11,2.146,2.146,0,0,0-.292-.975,1.289,1.289,0,0,0-.633-.562,1.263,1.263,0,0,0-1.149.177m1.275,1.286a1.585,1.585,0,0,1-.053.915,1.4,1.4,0,0,1-.5.75.712.712,0,0,1-.7.1.742.742,0,0,1-.47-.543,1.467,1.467,0,0,1,.084-.909,1.527,1.527,0,0,1,.532-.723.718.718,0,0,1,.665-.118.751.751,0,0,1,.445.532"
                                          transform="translate(-160.186 -579.642)" fill="#ffffff"/>
                                    <path id="Path_8672" data-name="Path 8672"
                                          d="M213.355,664.8a6.9,6.9,0,0,0-.283,1.361,1.675,1.675,0,0,0,.233.949,1.282,1.282,0,0,0,.775.521,1.234,1.234,0,0,0,.854-.04,1.438,1.438,0,0,0,.616-.629,5.731,5.731,0,0,0,.41-1.457l.33-1.743a5.662,5.662,0,0,1-.711-.166l-.426,2a4.494,4.494,0,0,1-.207.748.671.671,0,0,1-.287.3.444.444,0,0,1-.354.04.52.52,0,0,1-.3-.212.734.734,0,0,1-.111-.395,3.858,3.858,0,0,1,.147-.812l.486-1.954-.713-.185Z"
                                          transform="translate(-188.409 -586.37)" fill="#ffffff"/>
                                    <path id="Path_8673" data-name="Path 8673"
                                          d="M241.231,673.734l.824.137.225-1.669a7.151,7.151,0,0,1,.154-.833,1.321,1.321,0,0,1,.312-.554.444.444,0,0,1,.407-.142.388.388,0,0,1,.276.174.726.726,0,0,1,.121.4,6.832,6.832,0,0,1-.041,1l-.191,1.83c.268.048.538.035.812.06l.219-2.761a1.887,1.887,0,0,0-.171-1.107,1.033,1.033,0,0,0-.682-.516.818.818,0,0,0-.42.054,1.955,1.955,0,0,0-.5.342l.056-.417-.721-.118Z"
                                          transform="translate(-213.311 -592.104)" fill="#ffffff"/>
                                    <path id="Path_8674" data-name="Path 8674"
                                          d="M275.307,661.356a1.436,1.436,0,0,0-.431-.4.97.97,0,0,0-.486-.175,1.135,1.135,0,0,0-.991.565,2.974,2.974,0,0,0-.5,1.573,2.451,2.451,0,0,0,.368,1.586,1.318,1.318,0,0,0,1.066.683,1.06,1.06,0,0,0,.538-.095,1.749,1.749,0,0,0,.475-.443l.006.443.823-.043-.206-5.807-.689.036Zm-.191.753a1.76,1.76,0,0,1,.012,1.788.672.672,0,0,1-.629.336.763.763,0,0,1-.61-.382,1.483,1.483,0,0,1-.211-.908,1.561,1.561,0,0,1,.258-.871.7.7,0,0,1,.593-.315.8.8,0,0,1,.586.352"
                                          transform="translate(-241.306 -582.938)" fill="#ffffff"/>
                                    <path id="Path_8675" data-name="Path 8675"
                                          d="M308.351,670.644a1.326,1.326,0,0,0-.475-.354.809.809,0,0,0-.494-.064,1.131,1.131,0,0,0-.923.666,3,3,0,0,0-.316,1.616,2.52,2.52,0,0,0,.549,1.537,1.328,1.328,0,0,0,1.145.562,1.215,1.215,0,0,0,.507-.211,1.714,1.714,0,0,0,.427-.5l.057.441.816-.129-.633-4.139-.723.112Zm-.1.764a1.471,1.471,0,0,1,.341.841,1.443,1.443,0,0,1-.128.938.78.78,0,0,1-.577.441.7.7,0,0,1-.648-.294,1.532,1.532,0,0,1-.319-.884,1.562,1.562,0,0,1,.159-.89.752.752,0,0,1,.55-.4.673.673,0,0,1,.622.244"
                                          transform="translate(-270.706 -592.518)" fill="#ffffff"/>
                                    <path id="Path_8676" data-name="Path 8676"
                                          d="M335.163,656.308l-.373.054.146.9.386-.065.581,3.241.816-.168-.659-3.21.425-.123-.192-.874-.416.108-.312-1.513-.676.136Z"
                                          transform="translate(-296.04 -578.883)" fill="#ffffff"/>
                                    <path id="Path_8677" data-name="Path 8677"
                                          d="M347.353,650.974a.9.9,0,0,0-.01.495.816.816,0,0,0,.236.441.373.373,0,0,0,.361.111.389.389,0,0,0,.262-.278.775.775,0,0,0,.007-.488.861.861,0,0,0-.245-.442.355.355,0,0,0-.347-.112.4.4,0,0,0-.263.273m1.256,5.571.8-.216-1.036-4.052-.7.188Z"
                                          transform="translate(-307.115 -575.378)" fill="#ffffff"/>
                                    <path id="Path_8678" data-name="Path 8678"
                                          d="M364.777,658.63a2.627,2.627,0,0,0-.059,1.713,2.423,2.423,0,0,0,.889,1.368,1.294,1.294,0,0,0,1.323.207,1.471,1.471,0,0,0,.735-.589,1.923,1.923,0,0,0,.31-.976,2.669,2.669,0,0,0-.19-1.113,2.639,2.639,0,0,0-.586-.939,1.931,1.931,0,0,0-.816-.548,1.149,1.149,0,0,0-.823-.005,1.475,1.475,0,0,0-.782.882m1.763.161a1.711,1.711,0,0,1,.575,1.654.8.8,0,0,1-.477.548.7.7,0,0,1-.69-.1,1.369,1.369,0,0,1-.481-.753,1.57,1.57,0,0,1-.029-.918.732.732,0,0,1,.445-.534.642.642,0,0,1,.658.108"
                                          transform="translate(-322.404 -581.554)" fill="#ffffff"/>
                                    <path id="Path_8679" data-name="Path 8679"
                                          d="M392.022,649.542l.744-.376-.665-1.533c-.171-.4-.275-.661-.312-.787a1.505,1.505,0,0,1-.03-.642.532.532,0,0,1,.27-.372.4.4,0,0,1,.315-.018.753.753,0,0,1,.318.261,6.886,6.886,0,0,1,.463.871l.792,1.64.74-.374-1.25-2.444a1.905,1.905,0,0,0-.718-.849.9.9,0,0,0-.858-.058.839.839,0,0,0-.323.292,2.193,2.193,0,0,0-.234.583l-.175-.384-.653.322Z"
                                          transform="translate(-345.255 -570.149)" fill="#ffffff"/>
                                    <path id="Path_8680" data-name="Path 8680"
                                          d="M431.661,623.968a2.618,2.618,0,0,0,.4,1.657,2.323,2.323,0,0,0,1.215,1.052,1.287,1.287,0,0,0,1.342-.166,1.541,1.541,0,0,0,.543-.782,2.048,2.048,0,0,0,.031-1.033,2.952,2.952,0,0,0-.469-1.025,2.846,2.846,0,0,0-.818-.727,2,2,0,0,0-.928-.284,1.15,1.15,0,0,0-.786.244,1.547,1.547,0,0,0-.533,1.065m1.752-.361a1.439,1.439,0,0,1,.682.562,1.4,1.4,0,0,1,.3.863.805.805,0,0,1-.306.674.683.683,0,0,1-.689.1,1.406,1.406,0,0,1-.677-.61,1.47,1.47,0,0,1-.263-.852.834.834,0,0,1,.288-.642.689.689,0,0,1,.665-.1"
                                          transform="translate(-381.688 -550.591)" fill="#ffffff"/>
                                    <path id="Path_8681" data-name="Path 8681"
                                          d="M445.619,599.961l.206-.162,1.995,2.57.627-.558L446.4,599.3l.353-.334-.559-.674-.344.325-.323-.4A.478.478,0,0,1,445.4,598a.267.267,0,0,1,.091-.183l.228-.132-.514-.6a1.077,1.077,0,0,0-.452.226.728.728,0,0,0-.219.471,1.027,1.027,0,0,0,.177.548c.056.081.25.338.58.769l-.207.161Z"
                                          transform="translate(-393.086 -527.981)" fill="#ffffff"/>
                                    <path id="Path_8682" data-name="Path 8682"
                                          d="M467.786,580.9a1.647,1.647,0,0,0,.434-.782,1.433,1.433,0,0,0-.1-.764,1.8,1.8,0,0,0-.514-.7,1.853,1.853,0,0,0-.749-.425,1.459,1.459,0,0,0-.807.024,1.383,1.383,0,0,0-.146-.576,1.542,1.542,0,0,0-.359-.448,1.749,1.749,0,0,0-.764-.414,1.045,1.045,0,0,0-.726.089,2.318,2.318,0,0,0-.573.508l-.4.46,3.858,4Zm-3.371-3.03a.476.476,0,0,1,.364-.183.607.607,0,0,1,.385.183.706.706,0,0,1,.23.409.557.557,0,0,1-.164.432l-.109.127-.836-.817Zm1.486,1.51a.926.926,0,0,1,.6-.377.789.789,0,0,1,.551.23.685.685,0,0,1,.238.467,1.169,1.169,0,0,1-.347.645l-.134.158-1.019-1Z"
                                          transform="translate(-409.491 -510.028)" fill="#ffffff"/>
                                    <path id="Path_8683" data-name="Path 8683"
                                          d="M494.633,554.309a1.542,1.542,0,0,0-.585.107,1.067,1.067,0,0,0-.408.325,1.291,1.291,0,0,0-.1,1.188,2.867,2.867,0,0,0,.939,1.345,2.265,2.265,0,0,0,1.446.609,1.314,1.314,0,0,0,1.133-.532,1.332,1.332,0,0,0,.213-.519,1.575,1.575,0,0,0-.041-.645l.346.25.472-.71-3.363-2.318-.407.638Zm.463.592a1.432,1.432,0,0,1,.842.305,1.374,1.374,0,0,1,.564.724.789.789,0,0,1-.1.726.736.736,0,0,1-.642.3,1.343,1.343,0,0,1-.823-.341,1.549,1.549,0,0,1-.537-.734.772.772,0,0,1,.083-.692.715.715,0,0,1,.616-.292"
                                          transform="translate(-436.332 -489.357)" fill="#ffffff"/>
                                    <path id="Path_8684" data-name="Path 8684"
                                          d="M510.833,535.081l.425-.736-1.389-.86a5.967,5.967,0,0,1-.684-.457,1.385,1.385,0,0,1-.372-.5.505.505,0,0,1,.03-.459.4.4,0,0,1,.257-.2.723.723,0,0,1,.4.031,5.125,5.125,0,0,1,.867.428l1.544.872.357-.769-2.365-1.254a1.713,1.713,0,0,0-1.049-.261.966.966,0,0,0-.7.478.8.8,0,0,0-.111.426,1.567,1.567,0,0,0,.111.611l-.353-.216-.386.648Z"
                                          transform="translate(-448.686 -469.455)" fill="#ffffff"/>
                                    <path id="Path_8685" data-name="Path 8685"
                                          d="M524.9,499.092a1.252,1.252,0,0,0-.542.278,1.065,1.065,0,0,0-.3.4,1.213,1.213,0,0,0,.073,1.1,2.6,2.6,0,0,0,1.2,1.1,2.211,2.211,0,0,0,1.526.258,1.414,1.414,0,0,0,1.017-.8,1.18,1.18,0,0,0,.092-.575,1.6,1.6,0,0,0-.2-.593,1.986,1.986,0,0,1,.615.347.812.812,0,0,1,.2.407,1.075,1.075,0,0,1-.073.586,1.192,1.192,0,0,1-.274.394.8.8,0,0,1-.379.189l-.4.867a1.878,1.878,0,0,0,.784-.014,1.485,1.485,0,0,0,.64-.351,2.281,2.281,0,0,0,.5-.736,1.763,1.763,0,0,0-.109-1.637,2.579,2.579,0,0,0-1.293-.871l-3.24-1.225-.25.706Zm.59.458a1.274,1.274,0,0,1,.836.081,1.3,1.3,0,0,1,.683.548.789.789,0,0,1,.08.724.78.78,0,0,1-.559.466,1.284,1.284,0,0,1-.862-.12,1.263,1.263,0,0,1-.627-.562A.724.724,0,0,1,525,500a.654.654,0,0,1,.493-.449"
                                          transform="translate(-463.315 -440.552)" fill="#ffffff"/>
                                    <path id="Path_8686" data-name="Path 8686"
                                          d="M525.152,484.84l.28-.813-5.319-1.736-.244.679Z"
                                          transform="translate(-459.698 -426.47)" fill="#ffffff"/>
                                    <path id="Path_8687" data-name="Path 8687"
                                          d="M538.445,456.423a1.565,1.565,0,0,0-.505.339,1.11,1.11,0,0,0-.256.465,1.233,1.233,0,0,0,.336,1.133,2.755,2.755,0,0,0,1.366.859,2.242,2.242,0,0,0,1.561-.027,1.359,1.359,0,0,0,.848-.949,1.1,1.1,0,0,0,.012-.566,1.586,1.586,0,0,0-.273-.58l.413.1.147-.855-3.96-.759-.12.746Zm.648.36a1.465,1.465,0,0,1,.889-.059,1.385,1.385,0,0,1,.789.433.791.791,0,0,1-.319,1.252,1.36,1.36,0,0,1-.883.027,1.439,1.439,0,0,1-.763-.472.722.722,0,0,1-.183-.66.761.761,0,0,1,.47-.521"
                                          transform="translate(-475.422 -402.853)" fill="#ffffff"/>
                                    <path id="Path_8688" data-name="Path 8688"
                                          d="M533.8,423.409a1.318,1.318,0,0,0-.426.4,1.111,1.111,0,0,0-.207.491,1.206,1.206,0,0,0,.447,1.082,2.706,2.706,0,0,0,1.445.671,2.266,2.266,0,0,0,1.55-.226,1.381,1.381,0,0,0,.761-1.042,1,1,0,0,0-.049-.562,1.749,1.749,0,0,0-.377-.543l.426.035.044-.852-5.565-.356-.036.718Zm.7.265a1.368,1.368,0,0,1,.862-.166,1.424,1.424,0,0,1,.851.331.742.742,0,0,1,.269.688.807.807,0,0,1-.427.591,1.365,1.365,0,0,1-.891.139,1.472,1.472,0,0,1-.8-.362.7.7,0,0,1-.238-.637.824.824,0,0,1,.378-.585"
                                          transform="translate(-470.259 -373.608)" fill="#ffffff"/>
                                    <path id="Path_8689" data-name="Path 8689"
                                          d="M547.337,389.339a2.616,2.616,0,0,0-1.571.553,1.353,1.353,0,0,0-.541,1.182,1.472,1.472,0,0,0,.586,1.133,2.537,2.537,0,0,0,1.5.519,2.194,2.194,0,0,0,1.519-.436,1.48,1.48,0,0,0,.616-1.3,1.741,1.741,0,0,0-.263-.9,1.9,1.9,0,0,0-.7-.61l-.362.729a1.039,1.039,0,0,1,.441.793.725.725,0,0,1-.244.642,1.172,1.172,0,0,1-.7.3,23.982,23.982,0,0,0-.091-2.619Zm-.506,2.556a1.29,1.29,0,0,1-.506-.29,1.048,1.048,0,0,1-.251-.575.75.75,0,0,1,.183-.531.989.989,0,0,1,.524-.328,12.147,12.147,0,0,1,.05,1.724"
                                          transform="translate(-482.117 -344.266)" fill="#ffffff"/>
                                    <path id="Path_8690" data-name="Path 8690"
                                          d="M543.8,365.986a1.052,1.052,0,0,0-.135.571.821.821,0,0,0,.379.673,1.2,1.2,0,0,0,.822.213,1.444,1.444,0,0,0,1.186-.886l.15-.291c.137-.261.283-.4.429-.417a.29.29,0,0,1,.231.074.357.357,0,0,1,.109.251.7.7,0,0,1-.1.374l-.316.374.706.457a1.4,1.4,0,0,0,.617-1.253.988.988,0,0,0-.446-.846,1.233,1.233,0,0,0-.944-.2,1.253,1.253,0,0,0-.659.274,2.359,2.359,0,0,0-.507.71l-.164.315a.8.8,0,0,1-.172.26l-.14.063-.188-.063-.081-.193c-.011-.157.1-.355.34-.585l-.707-.386a1.431,1.431,0,0,0-.408.508"
                                          transform="translate(-480.735 -322.809)" fill="#ffffff"/>
                                    <path id="Path_8691" data-name="Path 8691"
                                          d="M533.81,335.094l-.15-.846-1.586.309a5.273,5.273,0,0,1-.818.125,1.18,1.18,0,0,1-.592-.125.5.5,0,0,1-.268-.356.43.43,0,0,1,.066-.33.762.762,0,0,1,.323-.261,6.618,6.618,0,0,1,.916-.266l1.72-.409-.153-.839-2.572.683a1.924,1.924,0,0,0-.978.535.979.979,0,0,0-.274.843.887.887,0,0,0,.213.419,1.5,1.5,0,0,0,.452.369l-1.929.382.133.7Z"
                                          transform="translate(-467.048 -293.659)" fill="#ffffff"/>
                                </g>
                            </svg>
                        </Link>
                    </Col>

                    <Col className="hamburger">
                          <span ref={hamburgerRef}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="18" viewBox="0 0 32 18">
                                    <g id="Component_25_3" data-name="Component 25 – 3" transform="translate(1 1)">
                                        <line id="Line_3967" data-name="Line 3967" x1="20" transform="translate(10 16)"
                                              fill="none" stroke={color} stroke-linecap="round" stroke-width="2"/>
                                        <line id="Line_3966" data-name="Line 3966" x1="30" transform="translate(0 8)"
                                              fill="none" stroke={color} stroke-linecap="round" stroke-width="2"/>
                                        <line id="Line_3965" data-name="Line 3965" x1="20" fill="none" stroke={color}
                                              stroke-linecap="round" stroke-width="2"/>
                                    </g>
                                </svg>

                          </span>

                        <span ref={hamburgerCloseRef}>
                            <img src={'/images/static/mobile-close.svg'}/>
                          </span>
                    </Col>

                    <div className="mobile-menu__items" ref={menuRef}>


                        <ul className="mobile-menu__items__ul">
                            <Accordion defaultActiveKey="">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header
                                        className={`has-child ${location.pathname === '/about' ? 'active' : ''}`}>
                                        About Us <img src={'/images/static/arrow-down.svg'}/>{" "}
                                        <img src={'/images/static/arrow-up.svg'}/>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <ul>
                                            <li>
                                                <Link to={"/about"}> National Heart Foundation
                                                    of Bangladesh
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to={"/founder"}> The Founder
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to={"/about"}> Objectives </Link>
                                            </li>
                                            <li>
                                                <Link to={"/our-activities"}> Upcoming Activities
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to={"/affiliated-body"}> Affiliated Body
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to={"/board-of-trustees"}> Board of Trustees
                                                </Link>
                                            </li>
                                        </ul>
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="1">
                                    <Accordion.Header
                                        className={`has-child ${location.pathname === '/' ? 'active' : ''}`}>
                                        NHFH & RI <img src={'/images/static/arrow-down.svg'}/>{" "}
                                        <img src={'/images/static/arrow-up.svg'}/>
                                    </Accordion.Header>
                                    <Accordion.Body>

                                        <ul>
                                            <li><Link to={'/hospital-activities'}>Hospital Activities</Link></li>
                                            <li><Link to={'/department'}>Departments</Link></li>
                                            <li><Link to={'/doctors-list'}>Our Doctors</Link></li>
                                            <li><Link to={'/service-rates'}>Hospital Service Rates</Link></li>

                                        </ul>
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="3">
                                    <Accordion.Header
                                        className={`has-child ${location.pathname === '/' ? 'active' : ''}`}>
                                        NHFB NCD Control & Prevention <img src={'/images/static/arrow-down.svg'}/>{" "}
                                        <img src={'/images/static/arrow-up.svg'}/>
                                    </Accordion.Header>
                                    <Accordion.Body>

                                        <ul>
                                            <li>
                                                <Link to={"/nhf-ccd"}> NHF CCD
                                                </Link>
                                            </li>
                                            <li>
                                                <a href={"https://epidemiology.nhf.org.bd/"} target={'_blank'} rel={'noopener noreferrer'}> Department of Epidemiology and Research
                                                </a>
                                            </li>
                                            <li>
                                                <a href={"https://epidemiology.nhf.org.bd/programs/lsff-advocacy"} target={'_blank'} rel={'noopener noreferrer'}> Prevention of Vitamin A and Vitamin D Deficiency
                                                </a>
                                            </li>
                                            <li>
                                                <a href={"https://epidemiology.nhf.org.bd/programs/road-safety-injury-prevention"} target={'_blank'} rel={'noopener noreferrer'}> Road Safety and Injury Prevention
                                                </a>
                                            </li>
                                            <li>
                                                <a href={"https://epidemiology.nhf.org.bd/programs/salt-reduction"} target={'_blank'} rel={'noopener noreferrer'}> Salt Intake Reduction
                                                </a>
                                            </li>
                                            <li>
                                                <Link to={"/control-prevention/slug?details=transfat-reduction-program"}> Trans-Fat Reduction Program
                                                </Link>
                                            </li>
                                            <li>
                                                <a href={"https://epidemiology.nhf.org.bd/programs/tobacco-control"} target={'_blank'} rel={'noopener noreferrer'}> Tobacco Control Program
                                                </a>
                                            </li>
                                            <li>
                                                <a href={"http://tobacco.nhf.org.bd/"} target={'_blank'} rel={'noopener noreferrer'}> Tobacco Cessation (Online)
                                                </a>
                                            </li>
                                            <li>
                                                <a href={"https://epidemiology.nhf.org.bd/programs/bhci"} target={'_blank'} rel={'noopener noreferrer'}> Hypertension Control Program
                                                </a>
                                            </li>
                                        </ul>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header
                                        className={`has-child ${location.pathname === '/' ? 'active' : ''}`}>
                                        International Affiliation <img src={'/images/static/arrow-down.svg'}/>{" "}
                                        <img src={'/images/static/arrow-up.svg'}/>
                                    </Accordion.Header>
                                    <Accordion.Body>

                                        <ul>
                                            <li><Link to={'/ufat'}>UFAT</Link></li>
                                            <li><Link to={'/conference'}>Conference</Link></li>
                                        </ul>
                                    </Accordion.Body>
                                </Accordion.Item>

                                <li><Link to={'/child-heart-details'}>Child's
                                    Heart</Link></li>
                                <li><Link to={'/publications'}>Our Publications</Link></li>
                                <li><Link to={'/research'}>Research</Link></li>
                                <li><Link to={'/news-events'}>News and Events</Link></li>
                                <li><Link to={'/career'}>Career</Link></li>
                                <li><Link to={'/contact'}>Contact</Link></li>
                            </Accordion>
                        </ul>

                        <div className={'social'}>
                            <div className={'facebook'}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
                                    <g id="Group_21266" data-name="Group 21266" transform="translate(-1063 -659)">
                                        <g id="Rectangle_1998" data-name="Rectangle 1998"
                                           transform="translate(1063 659)" fill="none" stroke="#fff" stroke-width="1"
                                           opacity="0.2">
                                            <rect width="25" height="25" rx="12.5" stroke="none"/>
                                            <rect x="0.5" y="0.5" width="24" height="24" rx="12" fill="none"/>
                                        </g>
                                        <path id="Path_26" data-name="Path 26"
                                              d="M1012.361,3918.425v-.9a1.965,1.965,0,0,1,.019-.315.612.612,0,0,1,.086-.219.351.351,0,0,1,.216-.149,1.551,1.551,0,0,1,.4-.041h.9V3915h-1.441a2.344,2.344,0,0,0-1.8.594,2.5,2.5,0,0,0-.546,1.75v1.086h-1.08v1.8h1.079v5.233h2.166v-5.233h1.442l.19-1.8Z"
                                              transform="translate(63.884 -3248.731)" fill="#fff"/>
                                    </g>
                                </svg>
                            </div>
                            <div className={'twitter'}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
                                    <g id="Group_21267" data-name="Group 21267" transform="translate(-1108 -659)">
                                        <g id="Rectangle_1998" data-name="Rectangle 1998"
                                           transform="translate(1108 659)" fill="none" stroke="#fff" stroke-width="1"
                                           opacity="0.2">
                                            <rect width="25" height="25" rx="12.5" stroke="none"/>
                                            <rect x="0.5" y="0.5" width="24" height="24" rx="12" fill="none"/>
                                        </g>
                                        <path id="Path_5915" data-name="Path 5915"
                                              d="M453.489,20.125a6.955,6.955,0,0,0,7-7q0-.16-.007-.318a5.011,5.011,0,0,0,1.228-1.274,4.912,4.912,0,0,1-1.413.387,2.47,2.47,0,0,0,1.082-1.362,4.933,4.933,0,0,1-1.563.6,2.464,2.464,0,0,0-4.195,2.245,6.988,6.988,0,0,1-5.073-2.571,2.463,2.463,0,0,0,.762,3.286A2.444,2.444,0,0,1,450.2,13.8c0,.01,0,.021,0,.031a2.462,2.462,0,0,0,1.975,2.413,2.459,2.459,0,0,1-1.111.042,2.464,2.464,0,0,0,2.3,1.71,4.938,4.938,0,0,1-3.057,1.054,5,5,0,0,1-.587-.034,6.968,6.968,0,0,0,3.773,1.106"
                                              transform="translate(665.284 656.625)" fill="#fff"/>
                                    </g>
                                </svg>
                            </div>
                            <div className={'insta'}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
                                    <g id="Group_21268" data-name="Group 21268" transform="translate(-1153 -659)">
                                        <g id="Rectangle_1998" data-name="Rectangle 1998"
                                           transform="translate(1153 659)" fill="none" stroke="#fff" stroke-width="1"
                                           opacity="0.2">
                                            <rect width="25" height="25" rx="12.5" stroke="none"/>
                                            <rect x="0.5" y="0.5" width="24" height="24" rx="12" fill="none"/>
                                        </g>
                                        <g id="Group_13724" data-name="Group 13724" transform="translate(-1007 -8363)">
                                            <path id="Path_5912" data-name="Path 5912"
                                                  d="M5.593,1.008c1.493,0,1.67.006,2.26.033a3.093,3.093,0,0,1,1.038.193,1.733,1.733,0,0,1,.643.418,1.733,1.733,0,0,1,.418.643,3.1,3.1,0,0,1,.193,1.038c.027.59.033.767.033,2.26s-.006,1.67-.033,2.26a3.1,3.1,0,0,1-.193,1.038A1.852,1.852,0,0,1,8.891,9.953a3.093,3.093,0,0,1-1.038.193c-.59.027-.767.033-2.26.033s-1.67-.006-2.26-.033a3.093,3.093,0,0,1-1.038-.193,1.733,1.733,0,0,1-.643-.418,1.733,1.733,0,0,1-.418-.643A3.093,3.093,0,0,1,1.04,7.853c-.027-.59-.033-.767-.033-2.26s.006-1.67.033-2.26a3.093,3.093,0,0,1,.193-1.038,1.733,1.733,0,0,1,.418-.643,1.733,1.733,0,0,1,.643-.418A3.093,3.093,0,0,1,3.333,1.04c.59-.027.767-.033,2.26-.033M5.593,0C4.074,0,3.883.006,3.287.034a4.106,4.106,0,0,0-1.358.26A2.741,2.741,0,0,0,.939.939a2.741,2.741,0,0,0-.645.991,4.106,4.106,0,0,0-.26,1.358C.006,3.883,0,4.074,0,5.593S.006,7.3.034,7.9a4.106,4.106,0,0,0,.26,1.358,2.741,2.741,0,0,0,.645.991,2.743,2.743,0,0,0,.991.645,4.106,4.106,0,0,0,1.358.26c.6.027.787.034,2.306.034S7.3,11.179,7.9,11.152a4.106,4.106,0,0,0,1.358-.26,2.86,2.86,0,0,0,1.636-1.636,4.106,4.106,0,0,0,.26-1.358c.027-.6.034-.787.034-2.306s-.006-1.709-.034-2.306a4.106,4.106,0,0,0-.26-1.358,2.743,2.743,0,0,0-.645-.991A2.741,2.741,0,0,0,9.256.294,4.106,4.106,0,0,0,7.9.034C7.3.006,7.112,0,5.593,0"
                                                  transform="translate(2167 9029)" fill="#fff"/>
                                            <path id="Path_5913" data-name="Path 5913"
                                                  d="M23.548,20.676a2.872,2.872,0,1,0,2.872,2.872,2.872,2.872,0,0,0-2.872-2.872m0,4.736a1.864,1.864,0,1,1,1.864-1.864,1.864,1.864,0,0,1-1.864,1.864"
                                                  transform="translate(2149.045 9011.045)" fill="#fff"/>
                                            <path id="Path_5914" data-name="Path 5914"
                                                  d="M61.429,15.384a.671.671,0,1,1-.671-.671.671.671,0,0,1,.671.671"
                                                  transform="translate(2114.82 9016.224)" fill="#fff"/>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                            <div className={'linkend'}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
                                    <g id="Group_21269" data-name="Group 21269" transform="translate(-1198 -659)">
                                        <g id="Rectangle_1998" data-name="Rectangle 1998"
                                           transform="translate(1198 659)" fill="none" stroke="#fff" stroke-width="1"
                                           opacity="0.2">
                                            <rect width="25" height="25" rx="12.5" stroke="none"/>
                                            <rect x="0.5" y="0.5" width="24" height="24" rx="12" fill="none"/>
                                        </g>
                                        <g id="Group_28" data-name="Group 28" transform="translate(1205.801 666.756)">
                                            <path id="LinkedIn"
                                                  d="M1096.5,3921.554v3.313h-1.942v-3.091c0-.776-.281-1.306-.984-1.306a1.061,1.061,0,0,0-1,.7,1.3,1.3,0,0,0-.065.469v3.226h-1.943s.026-5.234,0-5.777h1.943v.82l-.013.018h.013v-.018a1.932,1.932,0,0,1,1.751-.955C1095.539,3918.955,1096.5,3919.781,1096.5,3921.554Zm-7.964-5.249a1,1,0,1,0-.026,2h.013a1,1,0,1,0,.013-2Zm-.984,8.561h1.943v-5.777h-1.943Z"
                                                  transform="translate(-1087.435 -3916.306)" fill="#fff"/>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                            <div className={'youtube'}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
                                    <g id="Group_21270" data-name="Group 21270" transform="translate(-1243 -659)">
                                        <g id="Rectangle_1998" data-name="Rectangle 1998"
                                           transform="translate(1243 659)" fill="none" stroke="#fff" stroke-width="1"
                                           opacity="0.2">
                                            <rect width="25" height="25" rx="12.5" stroke="none"/>
                                            <rect x="0.5" y="0.5" width="24" height="24" rx="12" fill="none"/>
                                        </g>
                                        <g id="Group_31" data-name="Group 31" transform="translate(1250.515 667.71)">
                                            <path id="Path_29" data-name="Path 29"
                                                  d="M1176.069,3919.422c-.36-.425-1.025-.6-2.294-.6h-4.606c-1.3,0-1.974.185-2.333.638a3.24,3.24,0,0,0-.349,1.993v1.717c0,1.745.415,2.631,2.682,2.631h4.606a2.913,2.913,0,0,0,2.1-.529,2.759,2.759,0,0,0,.577-2.1v-1.717A3.158,3.158,0,0,0,1176.069,3919.422Zm-3.181,3.128-2.092,1.087a.322.322,0,0,1-.47-.284v-2.168a.32.32,0,0,1,.154-.273.325.325,0,0,1,.315-.011l2.092,1.081a.319.319,0,0,1,0,.568Z"
                                                  transform="translate(-1166.487 -3918.823)" fill="#fff"/>
                                        </g>
                                    </g>
                                </svg>

                            </div>
                        </div>
                    </div>

                </Row>
            </Container>
        </StyledMobileMenu>
    );
};


const StyledMobileMenu = styled.section`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 105px;
  z-index: 999;
  background-color: rgb(0 0 0 / 30%);
  display: flex;
  align-items: center;
  overflow: visible !important;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  //display: none;
  transition: all 0.3s ease;


  &.menu-visible {
    z-index: 10;
    background-color: #1E1E2E !important;
    transition: 0.8s all ease;
    .logo {
      display: flex;
      align-items: center;
      svg {
        #Group_20865 {
          path:not(:first-child) {
            fill: #ffffff!important;
          }
        }
      }
    }
  }

  .dc-btn {
    width: 100%;
  }


  .mobile-menu {

    .hamburger {
      position: relative;
      display: flex;
      align-items: center;
      //justify-content: flex-end;

      span {
        position: absolute !important;
        right: 15px !important;
        //height: 25px !important;

        &:nth-of-type(2) {
          display: none;
        }
      }

      &.menu-open span {
        &:nth-of-type(1) {
          display: none;
        }

        &:nth-of-type(2) {
          display: block;
          right: 20px;
        }
      }
    }

    &__items {
      position: absolute;
      background-color: #1E1E2E;
      height: calc(100vh - 85px);
      top: 100px;
      left: 0;
      width: 100%;
      z-index: 99;
      padding: 55px 15px 100px 15px;
      //overflow: auto;
      overflow: auto;
      transform: translate(100%,0%);

      .mobile-menu__items__contact {
        height: 40px;
        width: 100%;
        border-radius: 24px;
        text-align: center;
        background-color: ${hover};
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 70px;
        margin-top: 10px;

        p {
          font-size: 16px;
          font-weight: 500;
          color: #ffffff;
          line-height: 24px;

        }


      }

      &__top {
        ul {
          li {
            a {
              height: 35px;
              border-radius: 18px;
              background-color: rgba(136, 136, 136, 0.5);
              color: #ffffff;
              font-size: 12px;
              font-weight: 600;
              line-height: 18px;
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 30px;

              img {
                margin-right: 10px !important;
              }
            }

            &:nth-last-child(1) a {
              margin-bottom: 60px;
              background-color: ${hover};

              &:hover {
                color: #ffffff !important;
              }
            }
          }
        }
      }

      &__ul {
        li {
          padding-bottom: 20px;
          border-bottom: 1px solid rgb(255 255 255 / 20%);
          margin-bottom: 20px;

          &:nth-last-child(1) {
            border-bottom: 0;
          }

          a {
            color: rgb(255 255 255 / 70%);
            font-weight: 400;
            font-size: 20px;
            line-height: 28px;
          }

          &.active {
            border-color: rgb(255 255 255 / 20%);

            a {
              color: rgb(255 255 255 / 70%);
            }
          }
        }
      }

      .social {
        display: flex;
        gap: 20px;
        position: absolute;
        bottom: 40px;
      }

      @media (min-width: 768px) and (max-width: 991px) {
        padding: 55px 55px 60px 55px;
      }
    }
  }
  

  //accordion

  .accordion {
    background-color: rgb(30, 30, 46);
    z-index: 5;
    position: relative;

    .accordion-item {
      background-color: transparent;
      border: none;

      .accordion-header {
        .accordion-button {
          background-color: transparent;
          text-transform: capitalize;
          width: 100%;
          text-align: left;
          display: flex;
          justify-content: space-between;
          padding: 0;
          box-shadow: none;
          border: none;
          padding-bottom: 20px;
          //border-bottom: 1px solid rgb(255 255 255 / 20%);
          color: rgb(255 255 255 / 70%);
          font-weight: 400;
          font-size: 20px;
          line-height: 28px;
          transition: all 0.5s ease;

          &.collapsed {
            border-bottom: 1px solid rgb(255 255 255 / 20%) !important;
            color: rgb(255 255 255 / 70%);
            margin-bottom: 20px;
            transition: all 0.5s ease;
          }

          img {
            height: 20px;
            margin-top: 6px;

            &:nth-last-child(2) {
              display: none !important;
            }

            &:nth-last-child(1) {
              display: block !important;
            }
          }

          &.collapsed {
            img {
              &:nth-last-child(2) {
                display: block !important;
              }

              &:nth-last-child(1) {
                display: none !important;
              }
            }
          }

          &.collapsed {
            border-bottom: 1px solid #e1e4e6;
          }
        }

        &.active {
          .accordion-button {
            border-bottom: 1px solid rgb(255 255 255 / 20%);
            color: rgb(255 255 255 / 70%);
          }
        }
      }

      .accordion-body {
        padding-bottom: 5px;
        border-bottom: 1px solid rgb(255 255 255 / 20%);
        margin-bottom: 20px;
        padding-top: 20px;

        ul {
          li {
            border: none;
            padding: 0;
            margin: 0;
            font-size: 16px !important;
            line-height: 20px !important;


            a {
              font-size: 16px;
              line-height: 20px;
              font-weight: 500;
              color: #FFFFFF;
              padding: 15px 0;
              //margin-bottom: 20px;
              //border-bottom: 1px solid rgba(255, 255, 255, 0.5);
              display: block;

              svg {
                display: none;
              }

            }

            &:nth-of-type(1) a {
              padding-top: 0;
            }

            &:nth-last-of-type(1) a {
              border: none;
            }
          }
        }
      }

      &:nth-last-child(1) {
        .accordion-button {
          &.collapsed {
            border: none;
          }

        }
      }
    }
  }
}

@media (min-width: 992px) {
  display: none;
}


.contact-info {
  position: fixed;
  height: 100vh;
  top: 85px;
  left: 0px;
  right: 0px;
  background-color: #061524;
  padding: 50px 15px 20px 15px;
  transform: translate3d(100vw, 0px, 0px) !important;
  transition: all .4s ease;

  &__top {
    p {
      font-size: 20px;
      font-weight: 300;
      line-height: 28px;
      color: #FFFFFF;
      display: flex;
      margin-bottom: 60px;

      img {
        margin-right: 20px;

      }
    }

    a {
      font-size: 20px;
      line-height: 28px;
      font-weight: 500;
      color: #FFFFFF !important;
      display: flex;
      width: 100%;
      justify-content: space-between;
      padding-bottom: 20px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.5);
      margin-bottom: 40px;
    }
  }


  &__desc {
    &__single {
      &:nth-of-type(1) {
        margin-bottom: 40px;
      }

      h4 {
        font-size: 12px;
        line-height: 24px;
        color: rgba(255, 255, 255, 0.5);
      }

      a {
        color: #FFFFFF !important;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        border: 0
      }
    }

  }
}



`;
export default React.memo(MainMenu);
